import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {Input, ListGroup} from "reactstrap";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import PresentationTypeInput from "./components/PresentationTypeInput";
import PresentationTypeTextarea from "./components/PresentationTypeTextarea";
import PresentationTypeEmail from "./components/PresentationTypeEmail";
import PresentationTypePhone from "./components/PresentationTypePhone";
import PresentationTypeLibrary from "./components/PresentationTypeLibrary";
import CheckboxIcon from "../Components/checkboxIcon";

class Open extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tmp: 0,
    };

    this.presentationRef = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.getInput = this.getInput.bind(this);
  }

  getInput(){
    const {details, intl, question, validate, questionResponse} = this.props;
    const {presentationType, validationTexts} = this.props.question;
    const detail = details[0] || false;

    const defaultProps = {
      question,
      ref: this.presentationRef,
      value: detail.content || '',
      onChange: this.onChange,
      onUpdated: () => {
        this.props.onDetailsUpdated(details);
      },
      validate,
      validationTexts,
      intl,
      questionResponse
    };

    switch (presentationType) {
      case 'input': {
        return <PresentationTypeInput {...defaultProps} />;
      }
      case 'email': {
        return <PresentationTypeEmail {...defaultProps} />
      }
      case 'phone': {
        return <PresentationTypePhone {...defaultProps} />
      }
      case 'textarea': {
        return <PresentationTypeInput {...defaultProps} resize={true} />;
      }
      case 'library': {
        return <PresentationTypeLibrary {...defaultProps} />;
      }
      default:
        return <PresentationTypeInput {...defaultProps} />
    }
  }

  onChange(e){
    let {details, question} = this.props;
    let detail = details[0] ? details : false;

    const content = e.target.value;

    if(content !== '' && !!question.openRegex){
      const regex = new RegExp(question.openRegex, 'g');
      if(!regex.test(content)){
        return;
      }
    }

    const microTime = getCurrentMicroTime(this.props.startTime);

    if(content){
      detail = {
        microTime,
        content,
      }
    }else{
      detail = false;
    }

    this.props.onDetailsUpdated(detail ? [detail] : []);
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = this.presentationRef.current.validate();

    if (question.required && details.length === 0){
      validate.errors.push(validationTexts.required)
    }

    if(details.length > 0 && question.charsLengthMin > 0 && question.charsLengthMin > details[0].content.length){
      validate.errors.push(validationTexts.detail.charsLengthMin)
    }

    if(details.length > 0 && question.charsLengthMax > 0 && details[0].content.length > question.charsLengthMax){
      validate.errors.push(validationTexts.detail.charsLengthMax)
    }

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  render(){
    return this.getInput();
  }
}

Open.propTypes = {
  question: PropTypes.shape({
    required: PropTypes.bool.isRequired,
    presentationType: PropTypes.oneOf(['input', 'textarea', 'email', 'phone', 'library']).isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.string,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    detail: PropTypes.shape({
      contentEmpty: PropTypes.string,
      charsLengthMin: PropTypes.string,
      charsLengthMax: PropTypes.string,
    }),
    required: PropTypes.string
  }),
  intl: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Open);
